import { useMutation } from '@apollo/client';

import { logEvent } from 'features/Analytics/analytics';

import { UpdateTransactionNoteDocument } from './graphql/updateTransactionNote.gql';

const useUpdateTransactionNoteMutation = (transactionId: string) => {
  const [mutation, hook] = useMutation(UpdateTransactionNoteDocument);

  const updateTransactionNote = (note: string) =>
    mutation({
      onCompleted: () => {
        logEvent({ name: 'Note_Updated', properties: { transactionId } });
      },
      optimisticResponse: () => ({
        __typename: 'Mutation',
        updateTransactionNote: {
          __typename: 'TransactionPayload',
          transaction: {
            __typename: 'Transaction',
            note,
            transactionId,
            updatedAt: Date.now(),
          },
        },
      }),
      variables: {
        input: {
          note,
          transactionId,
        },
      },
    });

  return [updateTransactionNote, hook] as const;
};

export default useUpdateTransactionNoteMutation;
